module.exports = __webpack_public_path__ + "static/media/node.9c5bbc5e.png";